import { AlertTriangle, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useUIStore } from '@/stores';

export const PersistenceWarningBanner = () => {
  const { t } = useTranslation();
  const showPersistenceWarning = useUIStore((s) => s.showPersistenceWarning);
  const setShowPersistenceWarning = useUIStore((s) => s.setShowPersistenceWarning);

  if (!showPersistenceWarning) return null;

  return (
    <div className="w-full flex items-center bg-amber-50 dark:bg-amber-900/20 border-b border-amber-400 dark:border-amber-600 px-4 py-2">
      <AlertTriangle className="h-4 w-4 text-amber-600 dark:text-amber-400 flex-shrink-0 mr-2" />
      <span className="flex-1 text-sm text-amber-700 dark:text-amber-300">
        {t('persistence.warning', 'Your browser may delete app data after 7 days. Add to Home Screen to protect your estimates.')}
      </span>
      <button
        onClick={() => setShowPersistenceWarning(false)}
        className="ml-2 min-w-[44px] min-h-[44px] flex items-center justify-center text-amber-600 dark:text-amber-400 hover:text-amber-800 dark:hover:text-amber-200"
        aria-label={t('persistence.dismiss', 'Dismiss')}
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};
